import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AboutModalBox/about-modal-box';
import contentStyles from '@patternfly/react-styles/css/components/Content/content';
export var AboutModalBoxContent = function AboutModalBoxContent(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      trademark = _a.trademark,
      id = _a.id,
      _a$noAboutModalBoxCon = _a.noAboutModalBoxContentContainer,
      noAboutModalBoxContentContainer = _a$noAboutModalBoxCon === void 0 ? false : _a$noAboutModalBoxCon,
      props = __rest(_a, ["children", "className", "trademark", "id", "noAboutModalBoxContentContainer"]);

  return React.createElement("div", Object.assign({
    className: css(styles.aboutModalBoxContent, className),
    id: id
  }, props), React.createElement("div", {
    className: css('pf-c-about-modal-box__body')
  }, noAboutModalBoxContentContainer ? children : React.createElement("div", {
    className: css(contentStyles.content)
  }, children)), React.createElement("p", {
    className: css(styles.aboutModalBoxStrapline)
  }, trademark));
};